import React from 'react';

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  Button
} from 'reactstrap';

import FieldError from '../../../../../../helper/FieldError';

const WorkflowHttpRequestBodyRequestHeaderItemForm = props => {
  const { currentNode,
    headerRequestContentItem,
    callbacks: {
      onChangeHeaderRequestContentItem: callbackOnChangeHeaderRequestContentItem,
      onRemoveHeaderRequestContentItem: callbackOnRemoveHeaderRequestContentItem
    }
  } = props;

  const errorKey = (key) => {
    return `data.errors.header_request_content_${headerRequestContentItem.custom_id}_${key}`
  }

  // ---------- START KEY INPUT ----------
  const keyInput = () => {
    return(
      <FormGroup>
        <FieldError errors={ _.get(currentNode, errorKey('key')) }>
          <Label className='required'>
            Key
          </Label>
          <Input
            type="text"
            name="key"
            value={ headerRequestContentItem?.key || '' }
            invalid={ _.has(currentNode, errorKey('key')) }
            onChange={ event => callbackOnChangeHeaderRequestContentItem(event, headerRequestContentItem.custom_id) }
          />
        </FieldError>
      </FormGroup>
    )
  }
  // ---------- END KEY INPUT ----------
  // ----------------------------------------
  // ---------- START VALUE INPUT ----------
  const valueInput = () => {
    return(
      <FormGroup>
        <FieldError errors={ _.get(currentNode, errorKey('value')) }>
          <Label className='required'>
            Value
          </Label>
          <Input
            type="text"
            name="value"
            value={ headerRequestContentItem?.value || '' }
            invalid={ _.has(currentNode, errorKey('value')) }
            onChange={ event => callbackOnChangeHeaderRequestContentItem(event, headerRequestContentItem.custom_id) }
          />
        </FieldError>
      </FormGroup>
    )
  }
  // ---------- END VALUE INPUT ----------
  // ----------------------------------------
  // ---------- START REMOVE BUTTON ----------
  const removeButton = () => {
    return(
      <div className='text-end'>
        <Button
          outline
          color='danger'
          size='sm'
          onClick={ () => callbackOnRemoveHeaderRequestContentItem(headerRequestContentItem.custom_id) }
        >
          <i className='fas fa-trash'></i>&nbsp;
          { I18n.t('actions.destroy') }
        </Button>
      </div>
    )
  }
  // ---------- END REMOVE BUTTON ----------

  return(
    <Row>
      <Col md={ 12 }>
        <Card>
          <CardBody>
            { keyInput() }
            { valueInput() }
            { removeButton() }
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

export default WorkflowHttpRequestBodyRequestHeaderItemForm;
